<template>
    <a-modal :title="$t('hotel.invoice_parameters_configuration', { value: '' } /* 发票参数配置- */)" :visible="visible" :width="'70%'" @cancel="handleCancel" :footer="null">
        <div class="flexd-height">
            <a-table :rowKey="record => record.id" :pagination="false" :columns="columns" :data-source="apiList" class="mt10" :scroll="{ x: 600, y: 700 }">
                <span slot="name" slot-scope="text">
                    {{ text }}
                </span>
                <span slot="status" slot-scope="text, record">
                    <a-switch :checked-children="$t('web.show' /* 显示 */)" :un-checked-children="$t('web.hide' /* 隐藏 */)" :checked="record.status == 1" @change="handleChangeStatus(record)" />
                </span>
                <span slot="payDesc" slot-scope="text">
                    <span v-html="text"></span>
                </span>
                <span slot="action" slot-scope="text, record">
                    <a-button @click="handleShowConfig(record)" type="link">{{ $t('hotel.fill_parameters' /* 填写参数 */) }}</a-button>
                </span>
            </a-table>
        </div>
        <apiConfig ref="apiConfig" @ok="getDataList(channel_id)" />
    </a-modal>
</template>

<script>
import apiConfig from './api-config.vue';

export default {
    name: 'invoiceApi',
    components: { apiConfig },
    props: {
        dataInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            apiList: [],
            visible: false,
            form: this.$form.createForm(this),
            confirmLoading: false,
            channel_name: '',
            channel_id: '',
            columns: [
                {
                    title: this.$t('hotel.invoice_type' /* 开票方式名称 */),
                    dataIndex: 'invoice_cnname',
                    scopedSlots: { customRender: 'name' },
                    width: 200
                },
                {
                    title: this.$t('web.status' /* 状态 */),
                    dataIndex: 'status',
                    align: 'center',
                    scopedSlots: { customRender: 'status' },
                    width: 200
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' },
                    width: 200
                }
            ]
        };
    },

    methods: {
        getDataList(channel_id) {
            let data = {
                channel_id
            };
            this.$request.get({ url: 'getInvoiceMode', data }).then(res => {
                this.apiList = res.data.data;
            });
        },
        handleChangeStatus(recode) {
            let data = {
                channel_id: recode.channel_id,
                mode_id: recode.id,
                status: recode.status == 1 ? 0 : 1
            };
            this.$request.post({ url: 'editModeStatus', data }).then(res => {
                this.getDataList(recode.channel_id);
                this.$message.success(this.$t('web.modify_success' /* 修改成功 */));
            });
        },
        show(item) {
            this.channel_name = item.channel_name;
            this.channel_id = item.channel_id;
            this.getDataList(item.channel_id);
            this.visible = true;
        },
        handleShowConfig(record) {
            this.$refs.apiConfig.getDetail(record);
        },

        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        },
        mounted() {}
    }
};
</script>

<style scoped lang="less">
.flexd-height {
    height: 700px;
}
</style>
